import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import dayjs from 'dayjs';
import { Div } from '../../../Box';
import { getNested } from '../autocomplete.helpers';
export var AutocompleteItem = function (_a) {
    var displayKey = _a.displayKey, option = _a.option, _b = _a.format, format = _b === void 0 ? function (v) { return v; } : _b;
    if (!option)
        return null;
    var content = null;
    if (typeof option === 'object' || typeof option === 'function') {
        if (typeof displayKey === 'string') {
            var value = getNested(displayKey, option);
            content = _jsx(Div, { xxsmall: true, html: format(value), ellipsis: true });
        }
        else if (Array.isArray(displayKey)) {
            var value = getNested(displayKey, option);
            content = _jsx(Div, { xxsmall: true, html: format(value.join(' ')), ellipsis: true, overflowWrap: "normal" });
        }
        else if (typeof displayKey === 'function') {
            var Display = displayKey;
            content = _jsx(Display, { format: format, item: option });
        }
    }
    else if (['string', 'number'].includes(typeof option)) {
        content = _jsx(Div, { xxsmall: true, html: option, ellipsis: true });
    }
    else if (dayjs.isDayjs(option)) {
        content = _jsx(Div, { xxsmall: true, html: option.format('DD-MM-YYYY'), ellipsis: true });
    }
    else if (typeof (option === null || option === void 0 ? void 0 : option.toString) === 'function') {
        content = _jsx(Div, { xxsmall: true, html: option === null || option === void 0 ? void 0 : option.toString(), ellipsis: true });
    }
    return _jsx(_Fragment, { children: content });
};
